import http from 'hub-http/clients/apiClient';
const CONTENT_ASSISTANCE_SETTINGS_URL = 'content-assistance/v1/settings';
export const fetchContentAssistanceSettings = () => {
  return http.get(CONTENT_ASSISTANCE_SETTINGS_URL);
};